import React, { JSX } from 'react';
import cn from 'classnames';
import Button, { buttonStyles } from '@dealroadshow/uikit-button';
import Popover from '@dealroadshow/uikit-popover';
import IconClose from '@dealroadshow/uikit-icon/IconClose';
import styles from './Explanation.module.scss';

const Explanation = ({
  content,
  children,
  isVisible,
  hide,
  dataTest,
  className,
  contentClassName,
  wrapperClassName,
  closeOnClickOutside = true,
}: {
  content: React.ReactNode,
  children: JSX.Element,
  isVisible: boolean,
  hide: () => void,
  dataTest: string,
  className?: string,
  contentClassName?: string,
  wrapperClassName?: string,
  closeOnClickOutside?: boolean,
}) => (
  <Popover
    isDarkTheme
    content={ (
      <div className={ styles.popoverContent }>
        <Button
          type="button"
          className={ styles.explanationCloseBtn }
          onClick={ hide }
          dataTest={ `${ dataTest }CloseButton` }
        >
          <IconClose />
        </Button>
        <div>{ content }</div>
        <Button
          type="button"
          className={ cn(buttonStyles.btn, buttonStyles.action, styles.button) }
          onClick={ hide }
          dataTest={ `${ dataTest }GotItButton` }
        >
          Got it
        </Button>
      </div>
    ) }
    className={ cn(styles.popover, className) }
    contentClassName={ cn(styles.popoverContainer, contentClassName) }
    wrapperClassName={ wrapperClassName }
    isVisible={ isVisible }
    minPadding={ 10 }
    closeOnClickOutside={ closeOnClickOutside }
    triggerEvent={ false }
  >
    { children }
  </Popover>
);

export default Explanation;
